import { render, staticRenderFns } from "./BuyerOrderInfo.vue?vue&type=template&id=c07e2570&"
import script from "./BuyerOrderInfo.vue?vue&type=script&lang=js&"
export * from "./BuyerOrderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports